export default "__VITE_ASSET__BcXiOxBK__"